import { render, staticRenderFns } from "./HealthHistory.vue?vue&type=template&id=da3c5386&scoped=true&"
import script from "./HealthHistory.vue?vue&type=script&lang=js&"
export * from "./HealthHistory.vue?vue&type=script&lang=js&"
import style0 from "./HealthHistory.vue?vue&type=style&index=0&id=da3c5386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3c5386",
  null
  
)

component.options.__file = "HealthHistory.vue"
export default component.exports